import { useEffect, useState } from "react";
import { GetBidList } from "../../../Services/lib/nft";
import { UseApi } from "../../../hooks/use-api";
import styles from "./Auction.module.sass";
import Row from "./row";
import classNames from "classnames";
import Loader from "../../Loader";

const limit = 12;

export const Bids = ({ nftId }) => {
	const [{ isLoading }, getBidList] = UseApi({
		service: GetBidList,
	});

	const [data, setData] = useState([]);

	const [page, setPage] = useState(0);

	const [total, setTotal] = useState(0);

	const getData = async () => {
		const res = await getBidList({
			nftTemplate: nftId,
			page: 1 + limit * page,
			limit,
		});
		setData((p) => [...p, ...res.list]);
		setTotal(res.list_count);
	};

	useEffect(() => {
		getData();
	}, [page]);

	return (
		<div className={styles.wrapper}>
			<div className={styles.table}>
				<div className={styles.row}>
					<div className={styles.col}>Bidder</div>
					<div className={styles.col}>Amount</div>
					<div className={styles.col}>Date</div>
				</div>
				{data.map((e) => (
					<Row key={e._id} data={e} />
				))}
				{data.length === 0 && isLoading ? (
					<div className={styles.loaderCont}>
						<Loader />
					</div>
				) : null}
			</div>
			<div className={styles.foot}>
				{(page + 1) * limit < total ? (
					<button
						onClick={() => setPage((p) => p + 1)}
						className={classNames("button button-small", {
							disabled: isLoading,
						})}
					>
						{isLoading ? <Loader /> : null}
						Load more
					</button>
				) : null}
			</div>
		</div>
	);
};
